// Contact.jsx
import React, { useState } from 'react';
import { apiPost } from '../api/client';

const Contact = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });

    const [formSubmitted, setFormSubmitted] = useState(false);
    const [formError, setFormError] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setFormError(false);
        try {
            await apiPost('/contacts', formData);
            setFormSubmitted(true);
            setFormData({
                name: '',
                email: '',
                subject: '',
                message: ''
            });
        } catch (error) {
            setFormError(true);
        }
    };

    return (
        <div className="container">
            <h2 className="section-title">Connect With The Artist</h2>

            <div className="contact-container" style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '3rem',
                position: 'relative'
            }}>
                <div style={{
                    position: 'absolute',
                    width: '120px',
                    height: '120px',
                    top: -30,
                    left: -30,
                    backgroundImage: 'url("./images/bengali-pattern1.jpg")',
                    backgroundSize: 'contain',
                    backgroundRepeat: 'no-repeat',
                    opacity: 0.1,
                    zIndex: -1
                }}></div>

                <div className="contact-form slide-up" style={{
                    flex: '1',
                    minWidth: '300px',
                    backgroundColor: 'white',
                    padding: '2rem',
                    borderRadius: '8px',
                    boxShadow: '0 5px 30px rgba(0, 0, 0, 0.1)',
                    position: 'relative',
                    overflow: 'hidden'
                }}>
                    <div style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '5px',
                        background: 'linear-gradient(to right, var(--primary-color), var(--secondary-color))'
                    }}></div>

                    <h3 style={{
                        color: 'var(--primary-color)',
                        marginBottom: '1.5rem',
                        fontSize: '1.8rem',
                        position: 'relative',
                        display: 'inline-block'
                    }}>Send a Message</h3>

                    {formSubmitted ? (
                        <div className="success-message" style={{
                            backgroundColor: 'rgba(62, 142, 87, 0.1)',
                            color: '#3e8e57',
                            padding: '1rem',
                            borderRadius: '4px',
                            marginBottom: '1rem',
                            borderLeft: '4px solid #3e8e57'
                        }}>
                            <i className="fas fa-check-circle" style={{ marginRight: '0.5rem' }}></i>
                            Thank you for your message! I'll get back to you soon.
                        </div>
                    ) : null}

                    {formError ? (
                        <div className="error-message" style={{
                            backgroundColor: 'rgba(220, 53, 69, 0.1)',
                            color: '#dc3545',
                            padding: '1rem',
                            borderRadius: '4px',
                            marginBottom: '1rem',
                            borderLeft: '4px solid #dc3545'
                        }}>
                            <i className="fas fa-exclamation-circle" style={{ marginRight: '0.5rem' }}></i>
                            There was an error sending your message. Please try again.
                        </div>
                    ) : null}

                    <form onSubmit={handleSubmit}>
                        <div className="form-group" style={{ marginBottom: '1.5rem' }}>
                            <label className="form-label" htmlFor="name" style={{
                                display: 'block',
                                marginBottom: '0.5rem',
                                fontWeight: '500',
                                color: 'var(--primary-color)'
                            }}>Your Name</label>
                            <input
                                type="text"
                                id="name"
                                name="name"
                                className="form-input"
                                value={formData.name}
                                onChange={handleChange}
                                required
                                style={{
                                    width: '100%',
                                    padding: '0.8rem',
                                    border: '1px solid #e0e0e0',
                                    borderRadius: '4px',
                                    fontFamily: 'var(--font-secondary)',
                                    transition: 'border-color var(--transition-speed)',
                                    backgroundColor: 'rgba(255, 255, 255, 0.8)'
                                }}
                            />
                        </div>

                        <div className="form-group" style={{ marginBottom: '1.5rem' }}>
                            <label className="form-label" htmlFor="email" style={{
                                display: 'block',
                                marginBottom: '0.5rem',
                                fontWeight: '500',
                                color: 'var(--primary-color)'
                            }}>Your Email</label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                className="form-input"
                                value={formData.email}
                                onChange={handleChange}
                                required
                                style={{
                                    width: '100%',
                                    padding: '0.8rem',
                                    border: '1px solid #e0e0e0',
                                    borderRadius: '4px',
                                    fontFamily: 'var(--font-secondary)',
                                    transition: 'border-color var(--transition-speed)',
                                    backgroundColor: 'rgba(255, 255, 255, 0.8)'
                                }}
                            />
                        </div>

                        <div className="form-group" style={{ marginBottom: '1.5rem' }}>
                            <label className="form-label" htmlFor="subject" style={{
                                display: 'block',
                                marginBottom: '0.5rem',
                                fontWeight: '500',
                                color: 'var(--primary-color)'
                            }}>Subject</label>
                            <input
                                type="text"
                                id="subject"
                                name="subject"
                                className="form-input"
                                value={formData.subject}
                                onChange={handleChange}
                                required
                                style={{
                                    width: '100%',
                                    padding: '0.8rem',
                                    border: '1px solid #e0e0e0',
                                    borderRadius: '4px',
                                    fontFamily: 'var(--font-secondary)',
                                    transition: 'border-color var(--transition-speed)',
                                    backgroundColor: 'rgba(255, 255, 255, 0.8)'
                                }}
                            />
                        </div>

                        <div className="form-group" style={{ marginBottom: '1.5rem' }}>
                            <label className="form-label" htmlFor="message" style={{
                                display: 'block',
                                marginBottom: '0.5rem',
                                fontWeight: '500',
                                color: 'var(--primary-color)'
                            }}>Your Message</label>
                            <textarea
                                id="message"
                                name="message"
                                className="form-textarea"
                                value={formData.message}
                                onChange={handleChange}
                                required
                                style={{
                                    width: '100%',
                                    padding: '0.8rem',
                                    border: '1px solid #e0e0e0',
                                    borderRadius: '4px',
                                    fontFamily: 'var(--font-secondary)',
                                    transition: 'border-color var(--transition-speed)',
                                    minHeight: '150px',
                                    resize: 'vertical',
                                    backgroundColor: 'rgba(255, 255, 255, 0.8)'
                                }}
                            ></textarea>
                        </div>

                        <button type="submit" className="form-submit" style={{
                            backgroundColor: 'var(--primary-color)',
                            color: 'white',
                            padding: '0.8rem 1.5rem',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            transition: 'background-color var(--transition-speed)',
                            fontFamily: 'var(--font-secondary)',
                            fontSize: '1rem',
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '0.5rem'
                        }}>
                            <i className="fas fa-paper-plane"></i> Send Message
                        </button>
                    </form>
                </div>

                <div className="contact-info slide-up" style={{
                    flex: '1',
                    minWidth: '300px',
                    position: 'relative'
                }}>
                    <h3 style={{
                        color: 'var(--primary-color)',
                        marginBottom: '1.5rem',
                        fontSize: '1.8rem',
                        position: 'relative',
                        display: 'inline-block'
                    }}>
                        Contact Information
                        <span style={{
                            position: 'absolute',
                            bottom: '-5px',
                            left: '0',
                            width: '50%',
                            height: '2px',
                            background: 'var(--secondary-color)'
                        }}></span>
                    </h3>

                    <p style={{ marginBottom: '2rem' }}>
                        If you're interested in commissioning artwork, discussing potential exhibitions, or just want to connect about art and culture, please feel free to reach out through any of the following channels:
                    </p>

                    <div className="contact-item" style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        marginBottom: '1.5rem'
                    }}>
                        <div className="contact-icon" style={{
                            marginRight: '1rem',
                            width: '40px',
                            height: '40px',
                            backgroundColor: 'var(--primary-color)',
                            borderRadius: '50%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            color: 'white',
                            flexShrink: 0
                        }}>
                            <i className="fas fa-map-marker-alt"></i>
                        </div>
                        <div className="contact-text" style={{ flex: '1' }}>
                            <h4 style={{ marginBottom: '0.5rem', color: 'var(--accent-color)' }}>Studio Location</h4>
                            <p>AA-44, P.O.-Prafulla Kanan Kester</p>
                            <p>Kolkata, West Bengal, 700101</p>
                            <p>India</p>
                        </div>
                    </div>

                    <div className="contact-item" style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        marginBottom: '1.5rem'
                    }}>
                        <div className="contact-icon" style={{
                            marginRight: '1rem',
                            width: '40px',
                            height: '40px',
                            backgroundColor: 'var(--primary-color)',
                            borderRadius: '50%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            color: 'white',
                            flexShrink: 0
                        }}>
                            <i className="fas fa-envelope"></i>
                        </div>
                        <div className="contact-text" style={{ flex: '1' }}>
                            <h4 style={{ marginBottom: '0.5rem', color: 'var(--accent-color)' }}>Email</h4>
                            <p>samirdutta007@gmail.com</p>
                            {/* <p>gallery@samirdutta.com</p> */}
                        </div>
                    </div>

                    <div className="contact-item" style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        marginBottom: '1.5rem'
                    }}>
                        <div className="contact-icon" style={{
                            marginRight: '1rem',
                            width: '40px',
                            height: '40px',
                            backgroundColor: 'var(--primary-color)',
                            borderRadius: '50%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            color: 'white',
                            flexShrink: 0
                        }}>
                            <i className="fas fa-phone"></i>
                        </div>
                        <div className="contact-text" style={{ flex: '1' }}>
                            <h4 style={{ marginBottom: '0.5rem', color: 'var(--accent-color)' }}>Phone</h4>
                            <p>+91 93398 58128</p>
                            <p>+91 89812 01315</p>
                        </div>
                    </div>

                    <div className="contact-item" style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        marginBottom: '1.5rem'
                    }}>
                        <div className="contact-icon" style={{
                            marginRight: '1rem',
                            width: '40px',
                            height: '40px',
                            backgroundColor: 'var(--primary-color)',
                            borderRadius: '50%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            color: 'white',
                            flexShrink: 0
                        }}>
                            <i className="fas fa-clock"></i>
                        </div>
                        <div className="contact-text" style={{ flex: '1' }}>
                            <h4 style={{ marginBottom: '0.5rem', color: 'var(--accent-color)' }}>Studio Hours</h4>
                            <p>Tuesday - Saturday: 10am - 6pm</p>
                            <p>Sunday & Monday: By Appointment Only</p>
                        </div>
                    </div>

                    <h4 style={{
                        marginTop: '2.5rem',
                        marginBottom: '1rem',
                        color: 'var(--primary-color)',
                        borderBottom: '1px solid var(--secondary-color)',
                        paddingBottom: '0.5rem'
                    }}>Connect On Social Media</h4>

                    <div className="social-links" style={{
                        display: 'flex',
                        gap: '1rem',
                        marginTop: '1rem'
                    }}>
                        <a href="https://instagram.com/" target="_blank" rel="noopener noreferrer" style={{
                            color: 'var(--primary-color)',
                            fontSize: '1.5rem',
                            transition: 'color var(--transition-speed)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '40px',
                            height: '40px',
                            borderRadius: '50%',
                            backgroundColor: 'rgba(158, 42, 43, 0.1)'
                        }}>
                            <i className="fab fa-instagram"></i>
                        </a>
                        <a href="https://facebook.com/" target="_blank" rel="noopener noreferrer" style={{
                            color: 'var(--primary-color)',
                            fontSize: '1.5rem',
                            transition: 'color var(--transition-speed)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '40px',
                            height: '40px',
                            borderRadius: '50%',
                            backgroundColor: 'rgba(158, 42, 43, 0.1)'
                        }}>
                            <i className="fab fa-facebook"></i>
                        </a>
                        <a href="https://twitter.com/" target="_blank" rel="noopener noreferrer" style={{
                            color: 'var(--primary-color)',
                            fontSize: '1.5rem',
                            transition: 'color var(--transition-speed)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '40px',
                            height: '40px',
                            borderRadius: '50%',
                            backgroundColor: 'rgba(158, 42, 43, 0.1)'
                        }}>
                            <i className="fab fa-twitter"></i>
                        </a>
                        <a href="https://linkedin.com/" target="_blank" rel="noopener noreferrer" style={{
                            color: 'var(--primary-color)',
                            fontSize: '1.5rem',
                            transition: 'color var(--transition-speed)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '40px',
                            height: '40px',
                            borderRadius: '50%',
                            backgroundColor: 'rgba(158, 42, 43, 0.1)'
                        }}>
                            <i className="fab fa-linkedin"></i>
                        </a>
                        <a href="https://youtube.com/" target="_blank" rel="noopener noreferrer" style={{
                            color: 'var(--primary-color)',
                            fontSize: '1.5rem',
                            transition: 'color var(--transition-speed)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '40px',
                            height: '40px',
                            borderRadius: '50%',
                            backgroundColor: 'rgba(158, 42, 43, 0.1)'
                        }}>
                            <i className="fab fa-youtube"></i>
                        </a>
                    </div>
                </div>
            </div>

            {/* Map Section */}
            <div className="map-section" style={{
                marginTop: '4rem',
                borderRadius: '8px',
                overflow: 'hidden',
                boxShadow: '0 5px 30px rgba(0, 0, 0, 0.1)',
                position: 'relative'
            }}>
                <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '8px',
                    background: 'linear-gradient(to right, var(--primary-color), var(--secondary-color))',
                    zIndex: 10
                }}></div>

                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3684.187371698354!2d88.34296981495988!3d22.572853885182946!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a02771346e35b05%3A0xc245f834cbc825e9!2sIndian%20Museum!5e0!3m2!1sen!2sin!4v1617437035554!5m2!1sen!2sin"
                    width="100%"
                    height="450"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    title="Studio Location Map"
                ></iframe>
            </div>

            {/* Gallery Inquiries Section */}
            <div className="gallery-inquiries" style={{
                margin: '4rem 0',
                padding: '2rem',
                backgroundColor: 'rgba(227, 180, 72, 0.1)',
                borderRadius: '8px',
                textAlign: 'center',
                position: 'relative'
            }}>
                <div style={{
                    position: 'absolute',
                    top: '20px',
                    right: '20px',
                    width: '80px',
                    height: '80px',
                    backgroundImage: 'url("./images/kantha-pattern1.jpg")',
                    backgroundSize: 'contain',
                    backgroundRepeat: 'no-repeat',
                    opacity: 0.2
                }}></div>

                <h3 style={{
                    color: 'var(--primary-color)',
                    marginBottom: '1rem',
                    position: 'relative',
                    display: 'inline-block'
                }}>Gallery & Commission Inquiries</h3>

                <p style={{ maxWidth: '800px', margin: '0 auto 1.5rem' }}>
                    For gallery representation, exhibition opportunities, or commissioning a custom artwork,
                    please contact the studio directly with specific details about your requirements.
                </p>

                <a href="/commission" className="btn" style={{
                    backgroundColor: 'var(--accent-color)',
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '0.5rem'
                }}>
                    <i className="fas fa-palette"></i> Inquire About Commissions
                </a>
            </div>
        </div>
    );
};

export default Contact;